import { mergeTypographyStyles } from '../utils.js';
import { opalBase } from './base.js';
// Source Serif 4 has custom letter spacing in Opal
export const sourceSerif4 = mergeTypographyStyles(opalBase, {
    title5xl: {
        letterSpacing: -0.0625,
    },
    title4xl: {
        letterSpacing: -0.0625,
    },
    title3xl: {
        letterSpacing: -0.03125,
    },
});
//# sourceMappingURL=sourceSerif4.js.map